import { ArrowUpRight } from "lucide-react";

export function AdvertisementCard({ ad }) {
  return (
    <article className="card-surface group overflow-hidden transition-all duration-300 hover:-translate-y-0.5 hover:border-accent/50" style={{marginTop: -70, borderRadius: 20}}>
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={ad.image}
          alt={ad.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {ad.sponsored && (
          <span className="absolute left-2 top-2 rounded-full bg-background/80 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-muted-foreground backdrop-blur" style={{background: "rgba(36,36,45,0.2)", color: "black"}}>
            Sponsored
          </span>
        )}
      </div>
      <div className="space-y-2 p-4">
        <h3 className="text-sm font-semibold">{ad.title}</h3>
        <p className="text-xs leading-relaxed text-muted-foreground">
          {ad.description}
        </p>
        <button
          type="button"
          className="mt-1 inline-flex w-full items-center justify-center gap-1.5 rounded-lg bg-primary px-3 py-2 text-xs font-semibold text-primary-foreground transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {ad.cta}
          <ArrowUpRight className="h-3.5 w-3.5" />
        </button>
      </div>
    </article>
  );
}

export default AdvertisementCard;